



































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Meter from '@/data/models/meter';
import MeterCard from '@/components/meters/MeterCard.vue';
import Button from '@/components/commons/Button.vue';
import CreateUpdateMeter from '@/views/admin/meters/CreateUpdateMeter.vue';
import {IconMeter, MeterType, MeterTypeWeather} from '@/data/models/enums/meter-enum';
import EmptyData from '@/components/commons/EmptyData.vue';
import IdentificationsMultiple from "@/views/admin/meters/IdentificationsMultiple.vue";
import CreateMeterFromCSV from "@/components/meters/CreateMeterFromCSV.vue";
import dayjs from "dayjs";

@Component({
  components: {CreateMeterFromCSV, IdentificationsMultiple, EmptyData, CreateUpdateMeter, Button, MeterCard},
})
export default class ListMeters extends Vue {

  @Prop({required: true})
  buildingId: string;

  meters: Array<Meter> = [];
  meter: Meter = Meter.map({});
  opened = false;
  openImportCSV = false;
  requestDownloadForMeter: Meter = null;
  extractStartDate = dayjs().subtract(12, "month").format("YYYY-MM-DD");
  extractEndDate = dayjs().format("YYYY-MM-DD");
  processing = Vue.observable(false);

  openIdentificationsDialog = false;

  mounted(): void {
    this.getMeters();
  }

  onImported(): void {
    this.getMeters();
  }

  get breadCrumb(): string {
    return this.$store.state.breadcrumbName + this.$store.state.breadcrumbBuilding;
  }

  get orderedMeters(): Record<MeterType, Meter[]> {
    return this.meters.sort((a, b) => a.type.localeCompare(b.type)).reduce((acc, curr) => {
      if (Object.keys(MeterTypeWeather).includes(curr.type)) {
        (acc["WEATHER"] = acc["WEATHER"] || []).push(curr);
      } else {
        (acc[curr.type] = acc[curr.type] || []).push(curr);
      }

      // Sort by name in each type
      Object.keys(acc).forEach(key => {
        acc[key].sort((a, b) => a.name.localeCompare(b.name));
      });

      return acc;
    }, {} as Record<string, Meter[]>);
  }

  get isLoading(): boolean {
    return this.$store.state.loading;
  }

  goToHomeWithId(): void {
    this.$router.push(`/home/${this.buildingId}`);
  }

  icon(index: string): string {
    return IconMeter[index];
  }

  displaySeeButton(current: Meter): boolean {
    return current.referenceMeterId === null;
  }

  handleAction(meter?: Meter): void {
    if (meter == null) {
      this.opened = true;
      this.meter = Meter.map({buildingId: this.buildingId});
    } else {

      this.opened = true;
      if (meter.isRelatedToReference) {
        this.meter = Object.assign(Meter.map({}), meter.original);
      } else {
        this.meter = Object.assign(Meter.map({}), meter);
      }
    }
  }

  handleDownload(): void {
    if (this.requestDownloadForMeter == null) {
      return;
    }
    this.processing = true;
    this.$dao.meters.downloadRawData(this.requestDownloadForMeter.id, dayjs(this.extractStartDate), dayjs(this.extractEndDate))
        .then((content) => {
          const blob = new Blob([content], {type: 'text/csv'});
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `${this.requestDownloadForMeter.name}.csv`;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .finally(() => {
          this.processing = false;
          this.requestDownloadForMeter = null;
        });
  }

  handleClone(meter?: Meter): void {
    this.$dialog
        .confirm({actions: [{text: "Oui", key: true}], text: `Confirmer la duplication du compteur « ${meter.name} » ?`, title: "Dupliquer ?"})
        .then((result) => {
          if (result) {
            this.$store.commit('showLoader', true);
            this.$dao.meters.create(meter.clone())
                .then(() => this.getMeters())
                .finally(() => this.$store.commit('showLoader', false))
          }
        })
  }

  handleSee(meter: Meter): void {
    this.$store.commit('setBreadCrumbMeter', `${meter.name}`);
    this.$router.push({name: 'detailMeter', params: {meterId: meter.id}});
  }

  handleMultipleEdit(): void {
    this.$store.commit('setBreadCrumbMeter', null);
    this.$router.push({name: 'multipleMeterEdit', params: {buildingId: this.buildingId}})
  }

  dialogClosed(): void {
    this.opened = false;
    this.getMeters();
  }

  getMeters(): void {
    this.$store.commit('showLoader', true);

    // Set Breadcrum data
    this.$dao.buildings
        .getById(this.buildingId)
        .then(building => {
          this.$store.commit('setBreadCrumbBuilding', ` | ${building.name}`);
          return this.$dao.clients.getClientById(building.clientId);
        })
        .then(client => this.$store.commit('setBreadCrumbName', ` | ${client.nameSurname}`))

    this.$dao
        .meters
        .getAllByBuilding(this.buildingId)
        .then((result) => {
          if (result != null) {
            this.meters = result;
          } else {
            throw 'err';
          }
        })
        .catch(() => this.$dialog.error({text: this.$t('errors.getBuildings').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']}))
        .finally(() => this.$store.commit('showLoader', false));
  }
}
